// Checks any common "active" flag name/shape so inactive backend records never leak into dropdowns.
export const isRecordActive = (record) => {
  const flag = record?.active ?? record?.isActive ?? record?.status ?? record?.Active ?? record?.IsActive;

  if (flag === undefined || flag === null) {
    return true;
  }

  if (typeof flag === "boolean") {
    return flag;
  }

  if (typeof flag === "number") {
    return flag !== 0;
  }

  return !["inactive", "false", "0", "disabled"].includes(String(flag).trim().toLowerCase());
};

/**
 * Returns the first present id-like field from a record, trying every key name we've seen
 * across these APIs, so we never accidentally fall back to an unrelated/coincidental value.
 */
export const pickRecordId = (record, keys, label) => {
  for (const key of keys) {
    const value = record?.[key];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }

  console.warn(`Could not find an id field (tried: ${keys.join(", ")}) on record:`, record, label);
  return null;
};
